import React, { useContext, useMemo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListItemIcon,
  Paper,
  Radio,
} from '@material-ui/core';
import { SyncIcon } from 'components/Icons';
import api from 'api/Assessor/duvidas';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import ErrorHandler from 'utils/ErrorHandler';
import useStyle from './style';

interface Props {
  handleClose: () => void;
  idDuvida: number;
  isPublic?: boolean;
  coords?: DOMRect;
  isOpen?: boolean;
}

export default function ({
  handleClose,
  idDuvida,
  isPublic = false,
  coords,
  isOpen,
}: Props) {
  const { t } = useTranslation();
  const classes = useStyle();
  const { atualizarMensagens } = useContext(MensagensContext);
  const [isLoading, setLoading] = useState<boolean>(false);

  const backdropOpen = useMemo(() => {
    if (isOpen) return classes.backdropOpen;
  }, [isOpen, classes]);

  const paperOpen = useMemo(() => {
    if (isOpen) return classes.paperOpen;
  }, [isOpen, classes]);

  const paperStyle = useMemo(
    (): React.CSSProperties => ({
      // width: coords?.width,
      top: coords?.bottom,
      right: coords && window.innerWidth - coords.right,
    }),
    [coords]
  );

  const handleSelect = useCallback(
    async (flgPublica: boolean) => {
      if (flgPublica === isPublic) {
        handleClose();
        return;
      }
      setLoading(true);
      const { fail, response } = await api.alterarStatus({
        idPergunta: idDuvida,
        flgPublica,
      });
      setLoading(false);
      if (fail) {
        ErrorHandler(fail);
      }
      if (response && response.status === 200) {
        atualizarMensagens();
      }
      handleClose();
    },
    [idDuvida, handleClose, atualizarMensagens, isPublic]
  );

  return (
    <div
      className={[classes.backdrop, backdropOpen].join(' ').trim()}
      onClick={handleClose}
    >
      <Paper
        className={[classes.paper, paperOpen].join(' ').trim()}
        onClick={e => e.stopPropagation()}
        style={paperStyle}
      >
        <List>
          <ListItem onClick={() => handleSelect(false)} button>
            <ListItemIcon>
              <Radio checked={!isPublic} />
            </ListItemIcon>
            <ListItemText primary={t('AssessorMensagens.private')} />
            <ListItemSecondaryAction>
              {isPublic && isLoading && <SyncIcon animated />}
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem onClick={() => handleSelect(true)} button>
            <ListItemIcon>
              <Radio checked={isPublic} />
            </ListItemIcon>
            <ListItemText primary={t('AssessorMensagens.public')} />
            <ListItemSecondaryAction>
              {!isPublic && isLoading && <SyncIcon animated size={16} />}
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </Paper>
    </div>
  );
}
